import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Filter } from '../../../../models/filter.models';


@Component({
  selector: 'number-range',
  templateUrl: './number-range.component.html',
  styleUrls: ['./number-range.component.scss']
})
export class NumberRangeComponent implements OnInit {
  public numberRangeFormGroup : any;
  constructor(
    public controlContainer: ControlContainer
  ) {
  }

  @Input() data : Filter;
  ngOnInit(): void {
    this.numberRangeFormGroup = this.controlContainer.control
  }

}
